"use strict";
(self.webpackChunk = self.webpackChunk || []).push([
  [18],
  {
    4468: (e, t, o) => {
      var a = o(8786),
        n = (o(5306), o(6796)),
        r = o(9257),
        i = o(7925),
        s = o(9247);
      const c = (0, n.w)((e, t) => {
          const o = {
              container: e.querySelector("[data-linked-products-grid]"),
              colorNameElem: e.querySelector("[data-color-name]"),
              moreLinked: e.querySelector("[data-more-linked]"),
            },
            a = {
              linkedTag: e.dataset.linkedTag,
              handle: e.dataset.handle,
              currentColor: e.dataset.currentColor,
            };
          t.on("linkedProducts:fetched", (t) => {
            let { allLinkedProducts: n } = t;
            const c = n
                .filter((e) => e.tags.find((e) => e.includes("linked_")))
                .filter((e) => e.tags.find((e) => e.includes(a.linkedTag))),
              l = c.filter((e) => e.images.length > 0);
            if (!c || l.length < 0) return;
            c.length > 5 &&
              window.innerWidth > 640 &&
              o.moreLinked.classList.remove("hidden"),
              (o.container.innerHTML = c
                .map((e) => {
                  const { tags: t } = e,
                    o = t.find((e) => e.includes("color_")),
                    n = null == o ? void 0 : o.replace("color_", "");
                  return 0 === e.images.length
                    ? ""
                    : '\n        <div class="swiper-slide">\n          <a class="product__linked-products__item block transition-opacity duration-300 ease-in-out border '
                        .concat(
                          a.handle === e.handle ? "border-black active" : "",
                          '" href="/products/'
                        )
                        .concat(e.handle, '" data-color-name="')
                        .concat(
                          n,
                          '" data-linked-product-item>\n            <div class="aspect-ratio aspect-ratio--2/3 image__filter--grey">\n              '
                        )
                        .concat(
                          e.images.length > 0
                            ? (0, i.BH)(
                                e.images[0],
                                "mix-blend-multiply",
                                2 / 3
                              )
                            : (0, s.Z)(),
                          "\n            </div>\n          </a>\n        </div>\n      "
                        );
                })
                .join(""));
            const d = e.querySelector("[data-linked-products-slider]"),
              u = {
                modules: [r.W_],
                slidesPerView: 5,
                init: !1,
                loopPreventsSlide: !0,
                spaceBetween: 8,
                navigation: { nextEl: ".linked-button-next" },
              };
            new r.ZP(d, u).init();
            e.querySelectorAll("[data-linked-product-item]").forEach((e) => {
              const t = e.dataset.colorName;
              e.addEventListener("mouseenter", () => {
                "undefined" !== t && (o.colorNameElem.textContent = t);
              }),
                e.addEventListener("mouseleave", () => {
                  "undefined" !== t &&
                    (o.colorNameElem.textContent = a.currentColor);
                });
            });
          });
         if (window.sessionStorage.getItem("linkedProducts")) {
  const e = JSON.parse(sessionStorage.getItem("linkedProducts"));
  t.emit("linkedProducts:fetched", { allLinkedProducts: e });
} else {
  (async () => {
    try {
      const collections = [
                  "/collections/bestsellers?view=data",
                  "/collections/r-o-b?view=data",
                  "/collections/habella?view=data",
                  "/collections/icona?view=data",
                  "/collections/jeans?view=data",
                  "/collections/printede-bukser?view=data",
                  "/collections/udsalg?view=data"
                  // Add more collections if needed
      ];

      let allProducts = [];
      const seenHandles = new Set();
      const duplicateHandles = new Set();

      for (const url of collections) {
        const res = await fetch(url);
        const data = await res.json();
        for (const product of data) {
          if (seenHandles.has(product.handle)) {
            duplicateHandles.add(product.handle);
          }
          seenHandles.add(product.handle);
          allProducts.push(product);
        }
      }

      // Attach isDuplicate flag to each product
      const markedProducts = allProducts.map((product) => {
        return {
          ...product,
          isDuplicate: duplicateHandles.has(product.handle)
        };
      });

      sessionStorage.setItem("linkedProducts", JSON.stringify(markedProducts));

      if (window.ShopifyTheme?.EventBus?.emit) {
        ShopifyTheme.EventBus.emit("linkedProducts:fetched", {
          allLinkedProducts: markedProducts
        });
        console.log("✅ Linked products deduplicated:", markedProducts.length);
        console.log("🔁 Duplicates marked:", duplicateHandles.size);
      } else {
        console.warn("⚠️ ShopifyTheme.EventBus missing");
      }
    } catch (err) {
      console.error("❌ linkedProducts deduplication failed", err);
    }
  })();
}

        }),
        l = (0, n.w)((e) => {
          const t = e.querySelector("[data-mobile-slider]"),
            o = {
              modules: [r.tl],
              pagination: { el: ".swiper-pagination", type: "progressbar" },
              slidesPerView: 1,
              init: !1,
              spaceBetween: 0,
            },
            a = new r.ZP(t, o);
          a.init();
          const n = e.querySelector("[data-mobile-nav-slider]");
          new r.ZP(n, { slidesPerView: 5, init: !1, spaceBetween: 4 }).init();
          e.querySelectorAll("[data-mobile-nav-image]").forEach((e, t) => {
            e.addEventListener("click", () => {
              a.slideTo(t);
            });
          });
        }),
        d = (0, n.w)((e) => {
          const t = JSON.parse(e.querySelector(".js-data").innerHTML);
          (() => {
            const o = e.querySelector(".js-add-to-cart"),
              a = e.querySelector(".js-price"),
              n = e.querySelector(".js-compare-at-price"),
              r = (e) => {
                e
                  ? ((a.innerHTML = Shopify.formatMoney(
                      e.price,
                      theme.moneyFormat
                    )),
                    e.compare_at_price > e.price
                      ? ((n.hidden = !1),
                        (n.innerHTML = Shopify.formatMoney(
                          e.compare_at_price,
                          theme.moneyFormat
                        )))
                      : (n.hidden = !0),
                    e.available
                      ? ((o.innerHTML = theme.strings.addToCart),
                        (o.disabled = !1))
                      : ((o.innerHTML = theme.strings.soldOut),
                        (o.disabled = !0)))
                  : ((o.innerHTML = theme.strings.unavailable),
                    (o.disabled = !0));
              };
            new Shopify.OptionSelectors("product-".concat(t.id), {
              product: t,
              onVariantSelected: r,
              enableHistoryState: !0,
            });
            (() => {
              const e = document.querySelectorAll("[data-option-selector]"),
                t = document.querySelectorAll(".single-option-selector");
              e.forEach((e) => {
                const { option: o } = e.dataset,
                  a = Array.from(t).find((e) => e.dataset.option === o);
                e.addEventListener("change", () => {
                  a.value = e.value;
                  const t = new Event("change");
                  a.dispatchEvent(t);
                });
              });
            })();
          })();
        });
      var u = o(6358);
      const m = (0, n.w)((e) => {
        const t = e.querySelector("[data-image-container]"),
          o = e.querySelectorAll("[data-text-animation-elem]"),
          a = e.querySelector("[data-image-nav]"),
          n = u.p8.timeline();
        window.addEventListener("load", () => {
          window.innerWidth < 1024
            ? n
                .to(t, { opacity: 1, duration: 0.8, ease: "Power2.easeOut" })
                .to(
                  a,
                  { opacity: 1, y: 0, duration: 0.8, ease: "Power2.easeOut" },
                  "-=0.4"
                )
            : n
                .to(t, {
                  opacity: 1,
                  x: 0,
                  duration: 0.8,
                  ease: "Power2.easeOut",
                })
                .to(
                  o,
                  {
                    stagger: 0.1,
                    opacity: 1,
                    y: 0,
                    duration: 0.3,
                    ease: "Power2.easeInOut",
                  },
                  "-=0.4"
                );
        });
      });
      o(3948);
      const p = (0, n.w)((e) => {
        const t = [...e.querySelectorAll("[data-toggle]")],
          o = e.querySelectorAll("[data-content]"),
          a = document.querySelector("[data-sizeguide-button]");
        (o[0].style.maxHeight = "".concat(o[0].scrollHeight, "px")),
          t[0].classList.remove("text-gray-400"),
          t[0].classList.add("text-black"),
          t.forEach((e, a) => {
            const n = o[a];
            e.addEventListener("click", () => {
              t.forEach((e) => {
                e.classList.remove("text-black"),
                  e.classList.add("text-gray-400");
              }),
                e.classList.remove("text-gray-400"),
                e.classList.add("text-black"),
                o.forEach((e) => {
                  e.style.maxHeight = null;
                }),
                (n.style.maxHeight = "".concat(o[a].scrollHeight, "px"));
            });
          }),
          null == a ||
            a.addEventListener("click", (n) => {
              n.preventDefault();
              const r = a.getAttribute("href").replace("#", ""),
                i = t.find((e) => e.dataset.id === r),
                s = Number(e.offsetTop) - 100;
              t.forEach((e) => {
                e.classList.remove("text-black"),
                  e.classList.add("text-gray-400");
              }),
                i.classList.remove("text-gray-400"),
                i.classList.add("text-black"),
                o.forEach((e) => {
                  e.style.maxHeight = null;
                });
              const c = Array.from(o).find(
                (e) => "true" === e.dataset.sizeguide
              );
              (c.style.maxHeight = "".concat(c.scrollHeight, "px")),
                window.scrollTo({ top: s, left: 0, behavior: "smooth" });
            });
      });
      var g = o(833);
      const h = (0, n.w)((e, t) => {
        e.addEventListener("submit", async (o) => {
          o.preventDefault();
          const a = new FormData(e),
            n = e.querySelector("[data-submit-btn]");
          (n.textContent = theme.strings.adding),
            (n.disabled = !0),
            await fetch("".concat(e.action, ".js"), {
              method: e.method,
              body: a,
            }),
            await (0, g.x7)().then((e) => {
              t.emit("cart:updated", { cart: e }),
                t.emit("cart:drawer:toggle", { cartDrawerOpen: !0 }),
                (n.disabled = !1),
                (n.textContent = theme.strings.addToCart);
            });
        });
      });
      var y = o(6546),
        w = o(6970);
      const f = () =>
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.625 1.6832L10.3168 0.375L6 4.6918L1.6832 0.375L0.375 1.6832L4.6918 6L0.375 10.3168L1.6832 11.625L6 7.3082L10.3168 11.625L11.625 10.3168L7.3082 6L11.625 1.6832Z" fill="currentColor"/> </svg>';
      u.p8.registerPlugin(y.ScrollTrigger);
      const v = (0, n.w)(() => {
        const e = document.querySelectorAll("[data-main-mobile-image]"),
          t = document.querySelectorAll("[data-main-image]"),
          o = document.querySelectorAll("[data-modal-toggle]"),
          a = window.innerWidth,
          n = document.querySelector("[data-modal]"),
          i = (0, w.Z)(n),
          s = document.querySelector("[data-lightbox-slider]"),
          c = {
            modules: [r.W_],
            slidesPerView: 1,
            init: !1,
            spaceBetween: 0,
            navigation: {
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
            },
          },
          l = new r.ZP(s, c);
        l.init();
        const d = document.querySelectorAll("[data-zoom-image]"),
          u = document.querySelector("[data-modal-container]"),
          m = (e, t, o) => {
            const n = document.createElement("div");
            n.innerHTML = e;
            const r = n.querySelector("img").getAttribute("srcset").split(","),
              i = r[r.length - 1],
              s = document.createElement("img");
            s.setAttribute("srcset", i), s.classList.add("cursor-zoomOut");
            const c = document.createElement("div");
            c.setAttribute("data-zoomed-elem", "open"),
              c.appendChild(s),
              a < 641
                ? c.classList.add(
                    "product__zoom-container",
                    "flex",
                    "items-center",
                    "fixed",
                    "top-1/2",
                    "left-1/2",
                    "transform",
                    "-translate-y-1/2",
                    "-translate-x-1/2",
                    "w-full",
                    "h-full",
                    "bg-gray-200",
                    "z-100",
                    "overflow-scroll",
                    "transition-all",
                    "duration-500",
                    "ease-out"
                  )
                : (c.classList.add(
                    "product__zoom-container",
                    "fixed",
                    "top-1/2",
                    "left-1/2",
                    "transform",
                    "-translate-y-1/2",
                    "-translate-x-1/2",
                    "bg-gray-200",
                    "z-100",
                    "overflow-scroll",
                    "transition-all",
                    "duration-500",
                    "ease-out"
                  ),
                  (c.style.width = "".concat(t, "px")),
                  (c.style.height = "".concat(o, "px")));
            const l = document.createElement("button");
            l.classList.add("fixed", "top-20", "right-10", "z-101"),
              (l.innerHTML = f()),
              setTimeout(() => {
                u.appendChild(l);
              }, 1e3),
              u.appendChild(c);
            const d =
              (s.getBoundingClientRect().width -
                c.getBoundingClientRect().width) /
              2;
            c.scrollTo({ top: 0, left: d, behavior: "smooth" }),
              a > 640 &&
                setTimeout(() => {
                  (c.style.width = "100%"), (c.style.height = "100vh");
                }, 500);
            var m;
            (m = [c, l]).forEach((e) => {
              e.addEventListener("click", () => {
                m.forEach((e) => {
                  e.classList.add("hidden"),
                    setTimeout(() => {
                      e.remove();
                    }, 500);
                });
              });
            });
          },
          p = [...document.querySelectorAll("[data-lightbox-nav-item]")],
          g = (e) => {
            p.forEach((e) => {
              e.classList.remove("border-black");
            }),
              p[e].classList.add("border-black"),
              l.slideTo(e);
          };
        e.forEach((e, t) => {
          e.addEventListener("click", () => {
            g(t);
          });
        }),
          t.forEach((e, t) => {
            e.addEventListener("click", () => {
              g(t);
            });
          }),
          o.forEach((e) => {
            e.addEventListener("click", () => {
              i.toggle(), document.body.classList.toggle("no--scroll");
            });
          }),
          p.forEach((e, t) => {
            e.addEventListener("click", () => {
              g(t);
            });
          }),
          l.on("slideChange", (e) => {
            let { activeIndex: t } = e;
            g(t);
          }),
          d.forEach((e) => {
            e.addEventListener("click", () => {
              const t = e.innerHTML,
                o = e.getBoundingClientRect().width,
                a = e.getBoundingClientRect().height;
              m(t, o, a);
            });
          });
      });
      u.p8.registerPlugin(y.ScrollTrigger);
      const L = (0, n.w)((e) => {
          u.p8.to(e, { opacity: 1, y: 0, duration: 1, ease: "Power2.easeOut" });
        }),
        b = (0, n.w)((e) => {
          const t = [...document.querySelectorAll("[data-toggle]")],
            o = t.find((e) => "true" === e.dataset.description),
            a = [...document.querySelectorAll("[data-content]")],
            n = a.find((e) => "true" === e.dataset.description),
            r = e.querySelector("[data-description-button]"),
            i = document.querySelector("[data-bottom-information]");
          null == r ||
            r.addEventListener("click", (e) => {
              e.preventDefault(),
                t.forEach((e) => {
                  e.classList.remove("text-black"),
                    e.classList.add("text-gray-400");
                }),
                o.classList.remove("text-gray-400"),
                o.classList.add("text-black"),
                a.forEach((e) => {
                  e.style.maxHeight = null;
                }),
                (n.style.maxHeight = "".concat(n.scrollHeight, "px")),
                window.scrollTo({
                  top: i.offsetTop - 100,
                  left: 0,
                  behavior: "smooth",
                });
            });
        });
      var S = o(7668);
      const x = (0, n.w)((e) => {
        const { productId: t, baseUrl: o, limit: a } = e.dataset;
        (() => {
          const n = new XMLHttpRequest();
          n.open(
            "GET",
            ""
              .concat(
                o,
                "?section_id=template-product-recommendations&product_id="
              )
              .concat(t, "&limit=")
              .concat(a)
          ),
            (n.onload = () => {
              if (n.status >= 200 && n.status < 300) {
                const t = document.createElement("div");
                (t.innerHTML = n.response),
                  (0, S.ZH)(e),
                  e.insertAdjacentHTML(
                    "beforeend",
                    t.querySelector("[data-component]").innerHTML
                  );
                const o = e.querySelector(".swiper"),
                  a = {
                    slidesPerView: 2.5,
                    init: !1,
                    loopPreventsSlide: !0,
                    spaceBetween: 8,
                    breakpoints: { 740: { slidesPerView: 4 } },
                  };
                new r.ZP(o, a).init();
              }
            }),
            n.send();
        })();
      });
      a.Z.add({
        linkedProducts: c,
        mobileImages: l,
        product: d,
        productAnimations: m,
        productBottomDescription: p,
        productForm: h,
        productImages: v,
        productTextAnimation: L,
        productTopDescription: b,
        "product-recommendations": x,
      }),
        a.Z.mount();
    },
  },
  (e) => {
    e.O(0, [143], () => {
      return (t = 4468), e((e.s = t));
      var t;
    });
    e.O();
  },
]);
